import { styled, Typography } from '@mui/material';

const TypographyHeader = styled(Typography)(() => ({
  fontFamily: 'Inter',
  fontWeight: '500',
  margin: '0 1rem 0.75rem',
}));

export default TypographyHeader;
